import "../assets/Grid.css";
import { jsx as i } from "preact/jsx-runtime";
import { c as o } from "./index.2w0W-O47.js";
const c = "_grid_1vffa_9", a = {
  grid: c
}, f = ({ children: r, ...s }) => /* @__PURE__ */ i("div", { ...s, class: o(a.grid, s.class), children: r });
export {
  f as G
};
